

import InvoiceCard from "components/pages/health-facility/invoice-history/invoice-card";

export default function InvoiceView() {
  return <InvoiceCard />;
}
